import React from 'react';

/**
 * Componente reutilizável para campos de formulário
 * @param {object} props - Propriedades do componente
 * @param {string} [props.id] - ID único do campo
 * @param {string} [props.label] - Texto do label do campo
 * @param {boolean} [props.required=false] - Se o campo é obrigatório
 * @param {string} [props.error=''] - Mensagem de erro
 * @param {string} [props.hint=''] - Texto de ajuda
 * @param {React.ReactNode} [props.children] - Conteúdo do campo (input, select, etc)
 */
const FormField = ({
  id,
  label,
  required = false,
  error = '',
  hint = '',
  children,
  ...props
}) => {
  const hasError = error !== '';
  const fieldId = id || Math.random().toString(36).substring(2, 9);
  
  // Clonar o children e adicionar props se necessário
  const field = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        id: fieldId,
        'aria-describedby': hasError ? `${fieldId}-error` : (hint ? `${fieldId}-hint` : undefined),
        ...child.props
      });
    }
    return child;
  });
  
  return (
    <div className="mb-4">
      {label && (
        <label 
          htmlFor={fieldId}
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      {field}

      {hint && !hasError && (
        <p id={`${fieldId}-hint`} className="mt-1 text-sm text-gray-500">{hint}</p>
      )}

      {hasError && (
        <p id={`${fieldId}-error`} className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default FormField; 